import Cookies from "js-cookie";
import { IUser } from "../models/IUser";
import { Constants } from "./constants";
import { Utility } from "./utility";
import { PushMessageOptionsType } from "../models/types";
import { savePushSubscription } from "../actions/pushMessageActions";

export const getCurrentSubscription = (): Promise<PushSubscription | null> => {
    return new Promise((resolve, reject) => {
        navigator.serviceWorker.getRegistrations()
            .then(regs => {
                if (!regs) {
                    reject('no serviceworker registration found');
                }
                const swReg = regs[0];
                swReg.pushManager.getSubscription()
                    .then(subscription =>
                        resolve(subscription))
                    .catch(err => {
                        console.error(err);
                        reject(err);
                    });
            })
            .catch(err => {
                console.error(err);
                reject(err);
            });
    });
}

let subscriptionPromise: Promise<PushSubscription> | null = null;

export const getNotificationPermission = async () => {
    return Notification.requestPermission()
        .then(permission => {
            if (permission !== 'granted' && permission !== 'default') {
                console.error(`notification permission was not granted, but ${permission}`);
                return false;
            }
            return true;
        })
        .catch(err => console.error(err));
}

const getServiceworkerRegistration = () => {
    return new Promise((resolve, reject) => {
        if ('serviceWorker' in navigator) {
            navigator.serviceWorker.getRegistrations()
                .then(regs => {
                    if (regs !== undefined) {
                        resolve(regs[0]);
                    }
                })
                .catch(err => {
                    console.error(err);
                    reject(err);
                });
        } else {
            let err = 'your navigator does not support the use of Serviceworkers';
            console.error(err);
            reject(err);
        }
    });
}


/**
 * For initializing the PushMessage
 * @param user 
 */
export const subscribePushMessages: any = async (user: IUser) => {
    return new Promise(async (resolve, reject) => {
        getNotificationPermission()
            .then(ok => {
                if (!ok) {//no Notifications allowed, or error occurred
                    console.log('no Notifications allowed, or error occurred')
                    resolve(false);
                    return;
                }
                getServiceworkerRegistration()
                    .then(registration => {
                        if (registration === undefined) {
                            reject('no serviceworker registration found');
                        }
                        let publicKey = Cookies.get(Constants.VAPID_PUBLIC_KEY);
                        if (publicKey === undefined) {
                            reject('no VAPID publickey found');
                            return;
                        }
                        const options = {
                            userVisibleOnly: true,
                            applicationServerKey: Utility.urlBase64ToUint8Array(publicKey)
                        };
                        getSubscription(registration as ServiceWorkerRegistration, options)
                            .then((subscription: PushSubscription) => {
                                savePushSubscription(user, subscription)
                                    .then(ok => {
                                        if (ok === true) {
                                            console.log('saved subscription to server', subscription);
                                            resolve(true);
                                        }
                                    })
                                    .catch(err => {
                                        console.error('error saving subscription to server', err);
                                        reject(err);
                                    });
                            })
                            .catch(err => {
                                console.error(err);
                                reject(err);
                            })
                    })
                    .catch(err => {
                        console.error(err);
                        reject(err);

                    })
            })
            .catch(err => {
                console.error(err);
                reject(err);
            });
    });
}

export const getSubscription = (sw: ServiceWorkerRegistration, options: PushMessageOptionsType): Promise<PushSubscription> => {
    if (subscriptionPromise) {
        return subscriptionPromise;
    }
    subscriptionPromise = new Promise((resolve, reject) => {
        sw.pushManager.getSubscription()
            .then(subscription => {
                if (subscription !== null) {
                    resolve(subscription);
                } else {
                    sw.pushManager.subscribe(options)
                        .then(subscription => resolve(subscription))
                        .catch(err => reject(err));
                }
            })
            .catch(err => reject(err));
    });
    return subscriptionPromise;
}

/**
 * 
 * @param user explicitly unsubscribe
 * @param dispatch 
 */
export const unsubscribePush = (user: IUser) => {
    return new Promise((resolve, reject) => {
        getCurrentSubscription()
            .then(subscription => {
                if (subscription === null) {
                    resolve(true);
                    return;
                }
                // if (subscription) {

                    savePushSubscription(user, undefined)
                        .then(() => {
                            subscription.unsubscribe();
                            resolve(true);
                            // dispatch({ type: actionTypes.PUSH_SUBSCRIBED, payload: { push_subscribed: -1 } });
                        })
                        .catch(err => {
                            // debugger;
                            console.error('error saving subscription to server', err);
                            reject(err);
                        });
                // } else {
                //     resolve(true);
                // }
            })
            .catch(err => {
                console.error('error unsubscribing', err);
                reject('error unsubscribing')
            });
    })
}

